import I18n from 'i18n';
import Snack from '@effectivastudio/snackbar';
import { $d } from 'src/utils';
import DataBinder from 'src/lib/data_binder';
import PollBinder from './poll_binder';
import DateBinder from './date_binder';
import OrganizeBinder from './organize_binder';
// import MarketBinder from './market_binder';

function CardSchema(d) {
  const _ = {};

  if (d.isLiked === 'toggle') {
    _.text = this.$('.js-toggle-like > span').innerText;
    _.count = parseInt(_.text, 10) || 0;

    d.isLiked = !this.hasClass('.js-toggle-like', 'active');
    d.card_likes_count = _.count + (d.isLiked ? +1 : -1);
    d.card_likes_count < 0 && (d.card_likes_count = 0);
  }

  if (d.isBookmarked === 'toggle') {
    d.isBookmarked = !this.hasClass('.js-toggle-bookmark', 'active');
    d.isBookmarkedText = I18n.t(d.isBookmarked ? 'card.unbookmark.title' : 'card.bookmark.title');
  }

  if (d.isSubscribed === 'toggle') {
    d.isSubscribed = !this.hasClass('.js-toggle-subscribe', 'active');
    d.isSubscribedText = I18n.t(d.isSubscribed ? 'card.unsubscribe.title' : 'card.subscribe.title');
    this.el.dataset.isInitSubscriber = 'true';
  }

  if (d.isPinned === 'toggle') {
    d.isPinned = !this.hasClass('.js-toggle-pin', 'active');
    d.isPinnedText = I18n.t(d.isPinned ? 'card.unpin.title' : 'card.pin.title');
  }

  if (d.isAvailable === 'toggle') {
    d.isAvailable = !this.hasClass('.js-toggle-available', 'available');
    d.isAvailableText = I18n.t(d.isAvailable ? 'card.sold.title' : 'card.available.title');
  }

  if (d.isActive === 'toggle') {
    d.isActive = !this.hasClass('.js-toggle-active', 'active');
    d.kind = this.el.querySelector('.card-kind').innerHTML;

    const inactiveLabel = d.kind === 'Ich suche' ? 'card.not_active.title_looking' : 'card.not_active.title_offering';
    const activeLabel = d.kind === 'Ich suche' ? 'card.active.title_looking' : 'card.active.title_offering';

    d.isActiveText = I18n.t(d.isActive ? inactiveLabel : activeLabel);
  }

  if (d.isAttended === 'toggle') {
    if (d.attendType === 'cannot') { return; }

    d.isAttended = !$(this.el).find('.btn-participate').hasClass('active');
    d.eventAttendeesLimit = d.eventAttendeesLimit || this.el.dataset.eventAttendeesLimit;
    d.eventAttendeesLimit = d.eventAttendeesLimit ? parseInt(d.eventAttendeesLimit, 10) : null;

    const attendentsCount = this.$('.js-attendees-count > span');

    if (attendentsCount) {
      if (!('attendentsCountTaken' in d)) {
        d.attendentsCountTaken = this.getInteger('.js-attendees-count .taken') || 0;
        d.attendentsCountTaken += d.isAttended ? +1 : -1;
      }
    }
  }

  if ('attendentsCountTaken' in d) {
    d.hideAttendentsCount = d.attendentsCountTaken < 1;
    d.hideAttendentsButton = !d.isAttended && d.eventAttendeesLimit && d.attendentsCountTaken >= d.eventAttendeesLimit;
    if (d.eventAttendeesLimit != null) {
      d.hideEventBookedLabel = d.attendentsCountTaken < d.eventAttendeesLimit;
    }
  }

  if ('card_likes_count' in d) {
    d.card_likes_count === 0 && (d.isLiked = false);
    d.card_likes_count = I18n.t('card.like_html', { count: d.card_likes_count });
  }

  if ('poll_options' in d) {
    d.poll_options.forEach((o) => {
      PollBinder($d('.js-option', o.id), o);
    });
  }

  if ('date_options' in d) {
    d.options.forEach((o) => {
      DateBinder($d('.js-option', o.id), o);
    });

    d.date_options.forEach((o) => {
      DateBinder($d('.js-option', o.id), o);
    });
  }

  if ('organize_item' in d) {
    OrganizeBinder($d('.js-option', d.organize_item.id), d.organize_item);
  }

  if ('card_comments_count' in d) {
    if (String(d.card_comments_count).match(/\+|-/)) {
      _.text = this.$('.js-comment > span').innerText;
      _.count = parseInt(_.text, 10) || 0;
      d.card_comments_count = _.count + parseInt(d.card_comments_count, 10);
    }

    d.hasComments = d.card_comments_count >= 1;
    d.card_comments_count = I18n.t('card.comment_html', { count: d.card_comments_count });
  }

  if ('poll_votes_count' in d) {
    d.poll_votes_count = I18n.t('voting.x_members_voted', { count: d.poll_votes_count });
  }

  if ('date_votes_count' in d) {
    d.date_votes_count = I18n.t('voting.x_members_voted', { count: d.date_votes_count });
  }

  if ('organize_assignees_count' in d) {
    d.organize_assignees_count = I18n.t('assigning.x_members_assigned', { count: d.organize_assignees_count });
  }

  if ('marketplace_price' in d) {
    this.html('.price-wrapper', d.marketplace_price);
  }

  if ('engagement_state' in d) {
    this.html('.state-wrapper', d.engagement_state);
  }

  if (d.snackMsg) {
    if (d.snackMsg === 'subscribe') {
      Snack({ text: I18n.t(this.hasClass('.js-toggle-subscribe', 'active') ? 'card.subscribe.success_msg' : 'card.unsubscribe.success_msg') });
    } else if (d.snackMsg === 'bookmark') {
      Snack({ text: I18n.t(this.hasClass('.js-toggle-bookmark', 'active') ? 'card.bookmark.success_msg' : 'card.unbookmark.success_msg') });
    } else if (d.snackMsg === 'attend') {
      Snack({ text: d.attendMsg });
    } else if (d.snackMsg === 'poll_vote') {
      Snack({ text: I18n.t('snack.vote.success_msg') });
    } else if (d.snackMsg === 'date_vote') {
      Snack({ text: I18n.t('snack.vote.success_msg') });
    } else if (d.snackMsg === 'pin') {
      Snack({ text: I18n.t(this.hasClass('.js-toggle-pin', 'active') ? 'card.pin.success_msg' : 'card.unpin.success_msg') });
    } else if (d.snackMsg === 'available') {
      Snack({ text: I18n.t(this.hasClass('.js-toggle-available', 'available') ? 'card.sold.success_msg' : 'card.available.success_msg') });
    } else if (d.snackMsg === 'active') {
      Snack({ text: I18n.t(this.hasClass('.js-toggle-active', 'active') ? 'card.active.success_msg' : 'card.not_active.success_msg') });
    } else if (d.snackMsg === 'organize_assign') {
      Snack({ text: I18n.t('snack.assign.success_msg') });
    } else if (d.snackMsg === 'organize_unassign') {
      Snack({ text: I18n.t('snack.unassign.success_msg') });
    } else if (d.snackMsg === 'error') {
      Snack({
        text: I18n.t('snack.generic_error_msg'),
        customClass: 'snackbar-danger',
      });
    } else {
      Snack({
        text: d.snackMsg,
        customClass: 'snackbar-danger',
      });
    }
  }

  this
    .data(':root', 'stamp', d.updated_at)
    .toggleClass('.js-toggle-like', 'active', d.isLiked)
    .toggleClass('.js-toggle-bookmark', 'active', d.isBookmarked)
    .toggleClass('.js-toggle-subscribe', 'active', d.isSubscribed)
    .toggleClass('.js-toggle-pin', 'active', d.isPinned)
    .toggleClass('.js-toggle-available', 'available', d.isAvailable)
    .toggleClass('.js-toggle-active', 'active', d.isActive)
    // .toggleClass('.card-marketplace-price > span', 'hidden', d.isAvailable)
    .toggleClass(':root', 'pinned', d.isPinned)
    .toggleClass('.js-comment', 'active', d.hasComments)
    .html('.js-toggle-like > span', d.card_likes_count)
    .text('.js-toggle-bookmark span', d.isBookmarkedText)
    .text('.js-toggle-subscribe span', d.isSubscribedText)
    .text('.js-toggle-pin span', d.isPinnedText)
    .text('.js-toggle-available', d.isAvailableText)
    .text('.js-toggle-active', d.isActiveText)
    .text('.js-attendees-count .taken', d.attendentsCountTaken)
    .html('.js-comment > span', d.card_comments_count)
    .toggleClass('.js-attendees-count', 'hidden', d.hideAttendentsCount)
    .toggleClass('.js-event-booked-label', 'hidden', d.hideEventBookedLabel)
    .toggleClass('.js-toggle-attend', 'hidden', d.hideAttendentsButton)
    .text('.js-total-poll-voting-count', d.poll_votes_count)
    .text('.js-total-date-voting-count', d.date_votes_count)
    .text('.js-organize-assignees-count', d.organize_assignees_count);
}

export default DataBinder.create(CardSchema);
